// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ScheduleTwoToneSvg from "@fishx/icons-svg/es/asn/ScheduleTwoTone";
import FishxIcon from '../components/FishxIcon';

var ScheduleTwoTone = function ScheduleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ScheduleTwoToneSvg
  }));
};

ScheduleTwoTone.displayName = 'ScheduleTwoTone';
export default React.forwardRef(ScheduleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ScheduleTwoTone.js
// module id = 4065
// module chunks = 0